import React, { Component, Fragment } from "react";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";
import Typography from "@material-ui/core/Typography";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Table from "@material-ui/core/Table";
import Paper from "@material-ui/core/Paper";
import Logo from "../../img/powered_by_hg_logo.png";
import moment from "moment";
import "./EmbedGigText.css";

const BASE_URL = process.env.REACT_APP_BASE_URL;

@inject("embedGigStore", "gigPromotionStore")
@withRouter
@observer
class EmbedGigOrganisationText extends Component {
    state = {
        finishLoading: false,
        performData: null,
        tableBgColor: "#ffffff",
        tableFtColor: "#000000",
        hideToolbar: false,
    };

    componentDidMount() {
        this.loadData();
    }

    componentDidUpdate(prevProps) {
        if (this.props.match.params.id !== prevProps.match.params.id) {
            this.loadData();
        }
    }

    loadData = () => {
        const organisationId = this.props.match.params.id;
        const queryString = this.props.location.search;
        const params = new URLSearchParams(queryString);

        const startDate = params.get("startDate") || moment().startOf("month").format("MM-DD-YYYY");
        const endDate   = params.get("endDate")   || moment().add(4, "months").endOf("month").format("MM-DD-YYYY");
        const utcOffset = params.get("utcOffset") != null ? params.get("utcOffset") : null;
        const page      = params.get("page") || "1";
        const take      = params.get("take") || "20";
        const venueIds  = params.getAll("venueIds[]");

        const filterParams = { startDate, endDate, page, take };
        if (utcOffset != null) filterParams.utcOffset = utcOffset;
        if (venueIds.length > 0) filterParams.venueIds = venueIds;

        this.props.embedGigStore.loadEmbedCodeOrganisation(organisationId).then(() => {
            const store = this.props.embedGigStore;
            this.setState({
                tableBgColor: store.tableBgColor || "#ffffff",
                tableFtColor: store.tableFtColor || "#000000",
                hideToolbar: store.hideToolbar || false,
            });
        });

        this.props.gigPromotionStore.loadOrganisationEmbedGigs(organisationId, filterParams).then(gigs => {
            this.setState({ finishLoading: true, performData: this.processGigs(gigs) });
        }).catch(() => {
            this.setState({ finishLoading: true, performData: [] });
        });
    };

    processGigs = (gigs) => {
        if (!gigs || gigs.length === 0) return [];

        return gigs.slice().sort((a, b) => {
            const da = a.dateStart || "";
            const db = b.dateStart || "";
            return da < db ? -1 : da > db ? 1 : 0;
        }).map(gig => {
            const dateStart = moment(gig.dateStart);
            const actName   = gig.actName || (gig.act && (gig.act.actName || gig.act.profileName)) || "Unknown Act";
            const venueName = gig.venueName || (gig.venue && gig.venue.profileName) || "";
            return {
                eventId: gig.id,
                day:   dateStart.format("dddd"),
                date:  dateStart.format("D"),
                month: dateStart.format("MMMM"),
                year:  dateStart.format("YYYY"),
                time: gig.timeStart
                    ? moment(gig.timeStart, "HH:mm:ss").format("h.mma") + (gig.timeEnd ? " - " + moment(gig.timeEnd, "HH:mm:ss").format("h.mma") : "")
                    : "",
                actName,
                venueName,
                actId: (gig.act && gig.act.id) || gig.actId || null,
            };
        });
    };

    render() {
        const { performData, tableBgColor, tableFtColor, hideToolbar } = this.state;

        return (
            <Fragment>
                <Paper>
                    {!hideToolbar && (
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", padding: "12px 16px", borderBottom: "1px solid #eee" }}>
                            <Typography variant="caption" style={{ paddingRight: 8 }}>Powered By</Typography>
                            <img src={Logo} alt="hotgiggity logo" height="30px" />
                        </div>
                    )}
                    <div style={{ padding: "24px" }} className={!hideToolbar ? "gig-table-container" : ""}>
                        <Table className="preview-table">
                            <TableHead>
                                <TableRow>
                                    <TableCell className="gig-column" style={{ width: "33.33%", backgroundColor: tableBgColor, textAlign: "left", fontSize: "1.25rem", fontWeight: 700, color: "black", border: 0 }}>Date</TableCell>
                                    <TableCell className="gig-column" style={{ width: "33.33%", backgroundColor: tableBgColor, textAlign: "left", fontSize: "1.25rem", fontWeight: 700, color: "black", border: 0 }}>Time</TableCell>
                                    <TableCell className="gig-column" style={{ width: "33.33%", backgroundColor: tableBgColor, textAlign: "left", fontSize: "1.25rem", fontWeight: 700, color: "black", border: 0 }}>Act @ Venue</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {performData && performData.map((data, index) => (
                                    <TableRow key={data.eventId || index} style={{ verticalAlign: "top" }}>
                                        <TableCell className="gig-column" style={{ width: "33.33%", backgroundColor: tableBgColor, textAlign: "left", fontSize: "1rem", border: 0 }}>
                                            <Typography variant="body1" style={{ color: tableFtColor }}>
                                                {`${data.day}, ${data.date} ${data.month} ${data.year}`}
                                            </Typography>
                                        </TableCell>
                                        <TableCell className="gig-column" style={{ width: "33.33%", backgroundColor: tableBgColor, textAlign: "left", fontSize: "1rem", border: 0 }}>
                                            <Typography variant="body1" style={{ color: tableFtColor }}>
                                                {data.time}
                                            </Typography>
                                        </TableCell>
                                        <TableCell className="gig-column" style={{ width: "33.33%", backgroundColor: tableBgColor, textAlign: "left", fontSize: "1rem", border: 0 }}>
                                            <Typography variant="body1" style={{ color: tableFtColor }}>
                                                <span
                                                    style={{ fontWeight: "bold", cursor: data.actId ? "pointer" : "default", color: tableFtColor }}
                                                    onClick={() => data.actId && window.open(`${BASE_URL}profile/${data.actId}`)}
                                                >
                                                    {data.actName}
                                                </span>
                                                {data.venueName ? (
                                                    <span style={{ fontStyle: "italic", color: tableFtColor }}> @ {data.venueName}</span>
                                                ) : null}
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                ))}
                                {performData && performData.length === 0 && (
                                    <TableRow>
                                        <TableCell colSpan={3} style={{ backgroundColor: tableBgColor, textAlign: "center", padding: "40px 20px", border: 0 }}>
                                            <Typography style={{ color: tableFtColor }}>No upcoming gigs found.</Typography>
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </div>
                </Paper>
                {hideToolbar && (
                    <div className="embed-footer-grid" style={{ textAlign: "center", padding: "20px 0" }}>
                        <img className="imageFooter" onClick={() => window.open("https://hotgiggity.com", "_system")} alt="hotgiggity logo" src={Logo} height="40px" />
                    </div>
                )}
            </Fragment>
        );
    }
}

export default EmbedGigOrganisationText;
